import { Button as Btn, Card, Divider, Popover, Tooltip, Tag } from "antd";
import Member from "../../assets/icons/Avatar.png";
import pdf from "../../assets/icons/PDF.svg";
import moment from "moment";
import { InfoCircleOutlined } from "@ant-design/icons";
import { colors } from "../../share/constants/enums";
import OrderTimeModal from "./orderTimeModal";
import { useState } from "react";

const OrderCard = ({ receipt, openModal, data }) => {
  const [isOrderModal, setIsOrderModal] = useState(false);
  const buttonTextObj = {
    REDEEMED: "Redeem",
    NOT_REDEEMED: "Not Redeemed",
    COMPLETED: "Completed",
  };
  const handlePdfClick = () => {
    const pdfUrl = data?.receipt;
    if (pdfUrl) window.open(pdfUrl, "_blank");
  };
  const buttonText = buttonTextObj[data?.orderStatus];
  const content = (
    <div>
      <p className="text-primaryPurple font-medium">
        Promo Code:{" "}
        <span className="text-black">{data?.promoCodeId?.promoCode}</span>
      </p>
      <p className="text-primaryPurple font-medium">
        Discount:{" "}
        <span className="text-black">
          {data?.promoCodeId?.isPercent ? "" : "$"}
          {data?.promoCodeId?.discountAmount}
          {""}
          {data?.promoCodeId?.isPercent ? "%" : ""}
        </span>
      </p>
      {data?.promoCodeId?.spentPoints ? (
        <p className="text-primaryPurple font-medium">
          Spent Points:{" "}
          <span className="text-black">{data?.promoCodeId?.spentPoints}</span>
        </p>
      ) : (
        ""
      )}
    </div>
  );

  const hideModal = () => {
    setIsOrderModal(false);
  };
  const YesClickHandler = () => {
    setIsOrderModal(false);
  };
  const showModal = (data) => {
    setIsOrderModal(true);
  };
  return (
    <Card className="m-3 mb-0 border-1 border-gray-200 rounded-none shadow-md ">
      <Card className="h-7 border-b border-gray-200 rounded-none">
        <div className="flex items-center justify-between mx-2">
          <p className="text-primaryPurple font-bold text-lg">
            Order # {data?._id.slice(-6)}
            <span className="text-primaryOrange">
              {data?.giftId && " (Gifted)"}
            </span>
          </p>
          <Btn
            type={data?.orderStatus === "REDEEMED" ? "primary" : "default"}
            className={`${data?.orderStatus === "REDEEMED"
              ? "bg-primaryBlue hover:!bg-primaryBlue"
              : "bg-white !text-primaryOrange border-primaryOrange font-medium hover:!bg-white hover:!text-primaryOrange border-2 hover:!border-primaryOrange"
              } w-13`}
            onClick={openModal}
          >
            {buttonText}
          </Btn>
        </div>
      </Card>
      <div className="">
        <div className="flex justify-between">
          <div className="ml-1 mb-2">
            <div className="">
              <p className="text-lg text-primaryPurple font-bold mb-1">
                Client
              </p>

              <div className="flex items-center">
                <img
                  src={data?.userId?.profileImage ?? Member}
                  alt="Profile pic"
                  className="rounded-full w-3 h-3"
                />
                {data?.userId ? (
                  <span className="font-medium ml-1">
                    {`${data?.userId?.firstName} ${data?.userId?.lastName}`}
                  </span>
                ) : (
                  <span className="font-medium ml-1">Guest User</span>
                )}
              </div>
            </div>
            <div className="">
              <p className="text-primaryPurple font-bold text-lg mb-0">
                Service Name
              </p>
              <Tooltip
                title={data?.items
                  ?.map((item) => {
                    const name = item?.serviceDetails?.serviceName || item?.serviceId?.serviceName || "";
                    const variant = item?.serviceDetails?.variantTitle || item?.serviceId?.variantTitle || "";
                    return variant ? `${name} (${variant})` : name;
                  })
                  ?.join(", ")
                }
              >
                <div className="truncate w-20">
                  {data?.items?.map((item, i) => {
                    const name = item?.serviceDetails?.serviceName || item?.serviceId?.serviceName || "";
                    const variant = item?.serviceDetails?.variantTitle || item?.serviceId?.variantTitle || "";
                    return (
                      <span className="font-medium mt-0" key={i}>
                        {name}
                        {variant && <span>&nbsp;({variant})</span>}
                        {i < data?.items?.length - 1 && ", "}
                      </span>
                    );
                  })}
                </div>
              </Tooltip>
            </div>
            <div>
              <p className="text-primaryPurple font-bold text-lg mb-0">
                Date & Time{"  "}
                {data?.items?.some((item) => item?.appointmentDateTime) && (
                  <InfoCircleOutlined
                    onClick={showModal}
                    className="cursor-pointer mt-1 hover:color-red"
                  />
                )}
              </p>

              <p className="font-medium mt-0">
                <span>
                  {moment(data?.createdAt).format("MM/DD/YY hh:mm A")}
                </span>
              </p>
            </div>
            <div>
              <p className="text-primaryPurple font-bold text-lg mb-0">
                Order Type
              </p>

              <Tooltip
                title={data?.items
                  ?.map((item) => item?.serviceId?.promoDealType)
                  .join(", ")}
              >
                <div className="truncate w-20">
                  {data?.items?.map((item, i) => {
                    return (
                      <span className="font-medium mt-0" key={i}>
                        {item?.serviceId?.promoDealType
                          ? item?.serviceId?.promoDealType
                            .replace(/ _ /g, " ")
                            .charAt(0)
                            .toUpperCase() +
                          item?.serviceId?.promoDealType
                            .replace(/_/g, " ")
                            .slice(1)
                            .toLowerCase()
                          : ""}

                        {i < data?.items?.length - 1 && ", "}
                      </span>
                    );
                  })}
                </div>
              </Tooltip>
            </div>
            {receipt ? (
              <div className={data?.promoCodeId ? "" : "hidden truncate"}>
                <span className="font-medium mt-0 ">
                  PromoCode Applied{" "}
                  <Popover content={content}>
                    <InfoCircleOutlined className="cursor-pointer mt-1 hover:color-red" />
                  </Popover>
                </span>
              </div>
            ) : (
              ""
            )}
          </div>

          {receipt ? (
            <Divider type="vertical" className="border-boxGrey h-32.5 mt-1 " />
          ) : (
            <Divider type="vertical" className="border-boxGrey h-25 mt-4" />
          )}

          <div className="mr-4 ">
            {receipt ? (
              <div className={receipt ? "" : "invisible"}>
                <p className="text-lg text-primaryPurple font-bold mb-1">
                  Receipt
                </p>
                <Btn className="border-none p-0" onClick={handlePdfClick}>
                  <img src={pdf} alt="PDF Icon" />
                </Btn>
              </div>
            ) : (
              ""
            )}

            {/* <div className="">
              <p className="text-primaryPurple font-bold text-lg mb-0 ">
                Earned Points
              </p>
              <p className="font-medium mt-0">
                {data?.earnedPoints === 0 ? "0" : data?.earnedPoints}
              </p>
            </div> */}
            <div className="mt-1.5">
              <span className="text-primaryPurple font-bold text-lg mb-0">
                Total Amount
              </span>
              <p className="font-medium mt-0">
                ${data?.price ? data?.price : "0"}
              </p>
              {data?.items?.some((item) => item?.cartDiscountRuleBannerText) && (
                <div className="mt-0">
                  {Array.from(
                    new Set(
                      data?.items
                        ?.filter((item) => item?.cartDiscountRuleBannerText)
                        ?.map((item) => item?.cartDiscountRuleBannerText)
                    )
                  ).map((bannerText, index) => (
                    <Tag
                      key={index}
                      color="green"
                      className="mt-0"
                    >
                      {bannerText}
                    </Tag>
                  ))}
                </div>
              )}
            </div>
            <div>
              <span className="text-primaryPurple font-bold text-lg mb-0">
                Payout
              </span>
              <p className="font-medium mt-0">
                <p className="font-medium mt-0">
                  {data?.paymentId?.payout === null
                    ? "$0"
                    : `$${data?.paymentId?.payout}`}
                </p>
              </p>
            </div>
            <div>
              {" "}
              {receipt ? (
                ""
              ) : (
                <div className={data?.promoCodeId ? "" : "hidden truncate"}>
                  <p className="font-medium mt-0">
                    PromoCode Applied{" "}
                    <Popover content={content}>
                      <InfoCircleOutlined className="cursor-pointer mt-1 hover:color-red" />
                    </Popover>
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
        {isOrderModal && (
          <OrderTimeModal
            data={data}
            onCancel={hideModal}
            onOk={YesClickHandler}
          />
        )}
      </div>
    </Card>
  );
};
export default OrderCard;
